import { create } from 'zustand'
import type { RouteItem } from 'route/routes'

interface RouterConfigStore {
  currentRouterConfig: RouteItem | null
  setCurrentRouterConfig: (currentRouterConfig: RouteItem) => void
}

export default create<RouterConfigStore>()((set) => ({
  currentRouterConfig: null,
  setCurrentRouterConfig: (currentRouterConfig) =>
    set(() => ({ currentRouterConfig }))
}))

export type { RouterConfigStore }
